const skuCard = (skuCard) => {
  let { content, name, tags} = skuCard;
  let f = [ ...["key", content, name], ...tags];

  return f;
};

export default skuCard;
